// src/pages/ManifiestaCallPage.jsx
import React from 'react';
import { courseInfo } from '../../data/es/CourseStructure';
import { FaWhatsapp } from "react-icons/fa";
// import imgTransformacion2 from '../../assets/images/transformacion.png'; // opcional, ilustrativa
import imgTransformacion from '../../assets/images/perfil.png';

const ManifiestaCallPage = () => {

  return (
    <div className="bg-black text-white min-h-screen font-sans flex flex-col">
      {/* Fondo gradiente */}
      <div className="absolute inset-0 bg-gradient-to-b from-gray-950 via-black to-gray-900 opacity-95"></div>

      <main className="relative z-10 flex-grow container mx-auto px-4 py-12 flex flex-col items-center">
        {/* Encabezado */}
        <h1 className="text-3xl sm:text-4xl font-bold mb-4 text-center">
          {courseInfo.title}
        </h1>
        <p className="text-sm sm:text-lg text-gray-400 text-center max-w-2xl mb-8">
          {courseInfo.subtitle}
        </p>

        {/* Imagen o gráfico de transformación */}
        <img 
          src={imgTransformacion} 
          alt="Transformación Personal" 
          className="w-full max-w-xl mb-8 rounded-xl shadow-lg object-cover"
        />

        {/* Sección de transformación */}
        <div className="grid sm:grid-cols-2 gap-8 mb-12 text-center">
          <div className="bg-gray-900 p-6 rounded-xl shadow-md">
            <h3 className="font-semibold mb-2">Antes</h3>
            <ul className="text-gray-400 space-y-2">
              <li>Sin propósito</li>
              <li>Ansioso o deprimido</li>
              <li>Sin herramientas para crear tu vida</li>
            </ul>
          </div>
          <div className="bg-gray-900 p-6 rounded-xl shadow-md">
            <h3 className="font-semibold mb-2">Después</h3>
            <ul className="text-gray-400 space-y-2">
              <li>Feliz, alegre y en paz</li>
              <li>Empoderado y con claridad</li>
              <li>Herramientas para manifestar y crear desde tu poder</li>
            </ul>
          </div>
        </div>

        {/* Resumen de módulos */}
        <div className="w-full max-w-3xl flex flex-col gap-6 mb-12">
          {courseInfo.modules.map((module) => (
            <div key={module.module} className="flex flex-col sm:flex-row gap-4 items-center bg-gray-900 p-6 rounded-xl shadow-md">
              <img 
                src={module.landingPageImage} 
                alt={`Módulo ${module.module}`} 
                className="w-full sm:w-32 h-32 object-cover rounded-md shadow-md"
              />
              <div className="flex-1 text-center sm:text-left">
                <h4 className="font-semibold text-lg mb-2">{`Módulo ${module.module}: ${module.title}`}</h4>
                <p className="text-gray-400 text-sm">{module.landingPageDescription}</p>
              </div>
            </div>
          ))}
        </div>

        {/* Call to Action */}
        <div className="flex flex-col sm:flex-row gap-4 items-center">
          {/* Botón Calendly */}
          <a 
            href="https://calendly.com/tuusuario/clarificacion" 
            target="_blank" 
            rel="noopener noreferrer"
            className="bg-white text-black font-semibold px-6 py-3 rounded-xl shadow-md hover:bg-gray-200 transition-all"
          >
            Reservá tu Llamada de Clarificación
          </a>
          {/* Botón WhatsApp */}
          <a 
            href="https://wa.me/5491150254270" 
            target="_blank" 
            rel="noopener noreferrer"
            className="flex items-center justify-center gap-2 border border-gray-700 px-6 py-3 rounded-xl shadow-md text-white hover:bg-gray-800 transition-all"
          >
            <FaWhatsapp /> Consultar por WhatsApp
          </a>
        </div>
      </main>

      <footer className="relative z-10 text-center py-6 text-xs text-gray-600">
        © {new Date().getFullYear()} Gus • Aguiar | En misión de elevar y transformar.
      </footer>
    </div>
  );
};

export default ManifiestaCallPage;
